export default {
    label_task:{
        en:"Incentive Report",
        bn:'Variety Report'
    },
    label_achievement :{
        en:"Achievement(%)",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_from:{
        en:"Sales From",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_to:{
        en:"Sales To",
        bn:'ব্যবহারকারীরা'
    },
    label_target:{
        en:"Target",
        bn:"Target"
    },
    label_sales:{
        en:"Sales",
        bn:"Quantity"
    },
    label_sales_net:{
        en:"Net Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_gross:{
        en:"Gross Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_sales_cancel:{
        en:"Canceled Sales",
        bn:'ব্যবহারকারীরা'
    },
    label_difference:{
        en:"Difference",
        bn:'ব্যবহারকারীরা'
    },
    label_achievable:{
        en:"Achievable",
        bn:'ব্যবহারকারীরা'
    },
    label_unit_price_net:{
        en:"Net Unit Price",
        bn:"Amount"
    },
    label_incentive:{
        en:"Incentive",
        bn:"Quantity"
    },
    label_quantity_incentive:{
        en:"Incentive (Quantity)",
        bn:"Quantity"
    },
    label_amount_incentive:{
        en:"Incentive (Amount)",
        bn:"Quantity"
    },
}